import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { GameTitle } from "./GameTitle";
import { SplashChicken } from "./SplashChicken";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";

export class SplashState extends Phaser.State {

    public static currentInstance: SplashState;  

    public init(): void {
        
        SplashState.currentInstance = this;
    }
    
    public create(): void {

        this.add.image(0, 0, "texture_atlas_1", "HomeBG.png");

        let audioButton_px = GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO ? GameConstants.GAME_WIDTH - 55 * GameVars.scaleX : 10;

        const audioButton = this.add.button(audioButton_px, 10, "texture_atlas_1", this.onClickAudioButton, this);
        audioButton.scale.x = GameVars.scaleX;

        if (GameVars.gameData.muted) {
            audioButton.setFrames("btn_sound_off_on.png", "btn_sound_off_off.png", "btn_sound_off_on.png");
        } else {
            audioButton.setFrames("btn_sound_on_on.png", "btn_sound_on_off.png", "btn_sound_on_on.png");
        }

        const scaledItems = this.add.group();
        scaledItems.x = GameConstants.GAME_WIDTH / 2;
        scaledItems.y = GameConstants.GAME_HEIGHT / 2;
        scaledItems.scale.x = GameVars.scaleX;

        const gameTitle = new GameTitle(this.game);
        scaledItems.add(gameTitle);

        const splashChicken = new SplashChicken(this.game);
        this.add.existing(splashChicken);

        const startButton = new Phaser.Button(this.game, 0, 45, "texture_atlas_1", this.onClickStart, this);
        startButton.setFrames("btn_start_on.png", "btn_start_off.png", "btn_start_on.png", "btn_start_off.png");
        startButton.anchor.set(.5);
        scaledItems.add(startButton);

        const instructionsButton = new Phaser.Button(this.game, 0, 120, "texture_atlas_1", this.onClickInstructions, this);
        instructionsButton.setFrames("btn_instructions_on.png", "btn_instructions_off.png", "btn_instructions_on.png", "btn_instructions_off.png");
        instructionsButton.anchor.set(.5);
        scaledItems.add(instructionsButton);

        const statsButton = new Phaser.Button(this.game, 0, 175, "texture_atlas_1", this.onClickStats, this);
        statsButton.setFrames("btn_stats_on.png", "btn_stats_off.png", "btn_stats_on.png", "btn_stats_off.png");
        statsButton.anchor.set(.5);
        scaledItems.add(statsButton);

        // el texto del copyright
        if(GameConstants.SPONSOR !== GameConstants.SPONSOR_FUNO) {
            const copyrightLabel = this.add.text(GameConstants.GAME_WIDTH - 8, 13, " made by RavalMatic, licensed to " + GameConstants.SPONSOR, {font: "16px Arial", fill: "#000000"});
            copyrightLabel.anchor.set(1, .5);
            copyrightLabel.scale.x = GameVars.scaleX;

            // se activa el audio aqui
            AudioManager.playSound("music_splash", true, .3);
        }
        
        if (GameConstants.SPONSOR === GameConstants.SPONSOR_MINIJUEGOS) {
            const moreGamesButton = this.add.button(GameConstants.GAME_WIDTH - 45 * GameVars.scaleX, GameConstants.GAME_HEIGHT - 45, "texture_atlas_1", this.onClickMoreGames, this);
            moreGamesButton.setFrames("btn_more_games_minijuegos_on.png", "btn_more_games_minijuegos_off.png", "btn_more_games_minijuegos_on.png", "btn_more_games_minijuegos_off.png");
            moreGamesButton.anchor.set(.5);
            moreGamesButton.scale.x = GameVars.scaleX;
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
            const moreGamesButton = this.add.button(GameConstants.GAME_WIDTH - 55 * GameVars.scaleX,  GameConstants.GAME_HEIGHT - 55, "texture_atlas_1", this.onClickMoreGames, this);
            moreGamesButton.setFrames("logo-lagged-on.png", "logo-lagged.png", "logo-lagged-on.png", "logo-lagged.png");
            moreGamesButton.anchor.set(.5);
            moreGamesButton.scale.set(.5 * GameVars.scaleX, .5);
        }

        
    }

    public shutdown(): void {
        
        SplashState.currentInstance = null;
        
        super.shutdown();
    }

    private onClickMoreGames(): void {

        let win: Window;

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_MINIJUEGOS) {
            win = window.open("https://mnj.gs/atropellar", "_blank"); 
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
            win = window.open("https://lagged.com", "_blank"); 
        }
        
        win.focus();
    }

    private onClickAudioButton(button: Phaser.Button): void {

        GameManager.switchSound();

        if (GameVars.gameData.muted) {
            button.setFrames("btn_sound_off_on.png", "btn_sound_off_off.png", "btn_sound_off_on.png");
        } else {
            button.setFrames("btn_sound_on_on.png", "btn_sound_on_off.png", "btn_sound_on_on.png");
        }

        AudioManager.playSound("click");
    }

    private onClickStart(): void {

        if (/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)&&
            GameConstants.SPONSOR !== GameConstants.SPONSOR_YANDEX && GameConstants.SPONSOR !== GameConstants.SPONSOR_FUNO) {

            if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIX) {
                GameManager.enterRoadScene();
            } else {
                this.game.scale.startFullScreen();
                this.game.time.events.add(200, function(): void {
                    GameManager.enterRoadScene();
                }, this);
            }
            
        } else {
            GameManager.enterRoadScene();
        }

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
            }
        }

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO) {
            AudioManager.playSound("music_splash", true, .3);
        }

        AudioManager.playSound("click");
    }

    private onClickInstructions(): void {

        GameManager.enterInstructionsScene();

        AudioManager.playSound("click");
    }

    private onClickStats(): void {

        GameManager.enterStatsScene();

        AudioManager.playSound("click");
    }
}
